/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Candidates_HintInputs */

const vi_einvoice_candidates_hint = /** @type {(inputs: Einvoice_Candidates_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm một dòng nếu đúng là hóa đơn của đơn này. Bạn vẫn xem lại và sửa được.`)
};

/**

* @param {Einvoice_Candidates_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_candidates_hint = /** @type {((inputs?: Einvoice_Candidates_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Candidates_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_candidates_hint(inputs)
});